<section class="col dropdown-split"
  *ngIf="showProjectStatus && stageNameTitle.length > 0 && workFlowStagesList.length > 0">
  <div class="btn-group btn-group-sm">
    <div class="btn btn-danger d-flex align-items-center" [disabled]="preventEdit">
      <span>{{ stageNameTitle }} </span>
    </div>
    <button *ngIf="workFlowStagesList.length > 0" [disabled]="preventEdit" type="button"
      class="btn btn-danger dropdown-toggle dropdown-toggle-split" id="workFlowStagesList" data-toggle="dropdown"
      aria-haspopup="true" aria-expanded="false" data-reference="parent" aria-controls="workFlowStagesListDropDown">
      <span class="sr-only">Toggle Dropdown</span>
    </button>

    <div class="col-12 dropdown-menu dropdown-menu-right" aria-labelledby="workFlowStagesList">
      <ul class="list-unstyled" id="workFlowStagesListDropDown" role="menu">
        <li *ngFor="let row of workFlowStagesList" role="none">
          <button class="btn btn-clear dropdown-item font-bold" [disabled]="selectedStageId===row?.workflow_stage_id"
            (click)="selectStageName(row)" role="menuitem">{{ row?.stage_name }}</button>
        </li>
      </ul>
    </div>

  </div>

</section>
